const DB_NAME = 'APP_DB'
const DB_VERSION = 1
const STORE_NAME = 'items'

let DB

export default {
    async setToken(token) {
        return this.setItem('token', token)
    },
    async removeToken() {
        return this.removeItem('token')
    },
    async getToken() {
        return this.getItem('token', null).then(item => {
            return item.value
        })
    },

    async open() {
        return new Promise((resolve, reject) => {
            if (DB) {
                return resolve(DB)
            }
            let request = window.indexedDB.open(DB_NAME, DB_VERSION)
            request.onerror = e => {
                console.log('Error opening db', e)
                reject('Error')
            }
            request.onsuccess = e => {
                DB = e.target.result
                resolve(DB)
            }
            request.onupgradeneeded = e => {
                console.log('onupgradeneeded')
                let db = e.target.result
                let objectStore = db.createObjectStore(STORE_NAME, {
                    autoIncrement: true,
                    keyPath: 'key',
                })
            }
        })
    },
    async setItem(key, value) {
        let db = await this.open()
        return new Promise(resolve => {
            let trans = db.transaction([ STORE_NAME ], 'readwrite')
            trans.oncomplete = () => {
                resolve()
            }
            let store = trans.objectStore(STORE_NAME)
            store.openCursor().onsuccess = e => {
                let cursor = e.target.result
                if (cursor) {
                    if (cursor.value.key != key) {
                        store.delete(cursor.value.key)
                    }
                    cursor.continue()
                }
            }
            store.put({ key: key, value: value, })
        })
    },
    async removeItem(key) {
        if (!key) {
            return
        }
        let db = await this.open()
        return new Promise(resolve => {
            let trans = db.transaction([STORE_NAME], 'readwrite')
            trans.oncomplete = () => {
                resolve()
            }
            let store = trans.objectStore(STORE_NAME)
            store.delete(key)
        })
    },
    async getItem(key, defaultvalue) {
        let db = await this.open()
        return new Promise(resolve => {
            let trans = db.transaction([STORE_NAME], 'readonly')
            trans.oncomplete = () => {
                resolve(item)
            }
            trans.onerror = () => {
                resolve({ value: defaultvalue, })
            }
            let item = null
            let store = trans.objectStore(STORE_NAME)
            store.openCursor().onsuccess = e => {
                let cursor = e.target.result
                if (!cursor) {
                    throw new Error('store cursor no result')
                }
                item = cursor.value
            }
            store.openCursor().onerror = e => {
                throw e
            }
        })
    },
}

